export const translations: Record<string, Record<string, string>> = {
  zh: {
    'Core': '核心节点',
    'Sketch 2D': '2D 草图',
    'Solid Primitives': '实体图元',
    'Solid Operations': '实体操作',
    'Transform & Array': '变换与阵列',
    'Measure': '测量分析',
    'Data & Math': '数据与数学',
    'Basic & Params': '基础 & 参数',
    '2D Shapes': '2D 线框',
    '3D Solids': '3D 实体',
    'Features': '特征建模',
    'Analysis': '分析读取',
    'Data Flow': '数据流',
    'Math': '数学',
    'Transforms': '变换 & 阵列',
    'Organization': '组织管理',
    'Parameter': '参数',
    'Expression': '表达式',
    'Custom': '自定义',
    'Custom Nodes': '自定义节点',
    'Group': '成组',
    'Line': '直线',
    'Rectangle': '矩形',
    'Circle': '圆',
    'Arc': '圆弧',
    'Ellipse': '椭圆',
    'Polygon': '多边形',
    'Star': '星形',
    'Box': '立方体',
    'Sphere': '球体',
    'Capsule': '胶囊体',
    'Cylinder': '圆柱',
    'Cone': '圆锥',
    'Frustum': '圆台',
    'Torus': '圆环体',
    'Ellipsoid': '椭球体',
    'Extrude': '拉伸体',
    'Revolve': '旋转体',
    'Sweep': '扫掠体',
    'Loft': '放样体',
    'Boolean': '布尔运算',
    'Bounding Box': '包围盒',
    'Surface Area': '表面积',
    'Volume': '体积',
    'Centroid': '质心',
    'Number Range': '数字序列',
    'Range By Count': '按数量分段',
    'List Create': '创建列表',
    'List Length': '列表长度',
    'List Get Item': '列表取项',
    'List Flatten': '列表压平',
    'List First': '列表首项',
    'List Last': '列表末项',
    'List Join': '列表拼接',
    'List Slice': '列表切片',
    'List Reverse': '列表反转',
    'List Unique': '列表去重',
    'List Repeat': '列表重复',
    'Vector Create': '创建向量',
    'Vector Add': '向量相加',
    'Vector Subtract': '向量相减',
    'Vector Scale': '向量缩放',
    'Vector Length': '向量长度',
    'Vector Normalize': '向量归一化',
    'Vector Dot': '向量点乘',
    'Vector Cross': '向量叉乘',
    'Vector Distance': '向量距离',
    'Vector Angle': '向量夹角',
    'Vector Lerp': '向量插值',
    'Add': '加法',
    'Minus': '减法',
    'Multiply': '乘法',
    'Divide': '除法',
    'Power': '幂',
    'Absolute': '绝对值',
    'Clamp': '钳制',
    'Remap': '重映射',
    'Fillet': '倒角',
    'Move': '移动',
    'Rotate': '旋转',
    'Scale': '缩放',
    'Mirror': '镜像',
    'Array Linear': '线性阵列',
    'Array Grid': '矩形阵列',
    'Array Polar': '环形阵列',
    'Value': '值',
    'Result': '结果',
    'start': '起点',
    'end': '终点',
    'width': '宽度',
    'height': '高度',
    'center': '中心',
    'radius': '半径',
    'start_angle': '起始角',
    'end_angle': '终止角',
    'radius_x': 'X半径',
    'radius_y': 'Y半径',
    'radius_z': 'Z半径',
    'radius_top': '顶半径',
    'radius_bottom': '底半径',
    'radius_main': '主半径',
    'radius_tube': '管半径',
    'inner_radius': '内半径',
    'outer_radius': '外半径',
    'points': '角数',
    'sides': '边数',
    'base': '基点',
    'size_x': 'X长度',
    'size_y': 'Y宽度',
    'size_z': 'Z高度',
    'length': '长度',
    'shape': '轮廓',
    'angle': '角度',
    'axis': '轴向',
    'path': '路径',
    'section_a': '截面A',
    'section_b': '截面B',
    'object_a': '物体A',
    'object_b': '物体B',
    'item_1': '对象1',
    'item_2': '对象2',
    'item_3': '对象3',
    'item_4': '对象4',
    'group': '组合',
    'operation': '运算',
    'geometry': '几何',
    'min': '最小点',
    'max': '最大点',
    'size': '尺寸',
    'area': '面积',
    'volume': '体积',
    'centroid': '质心',
    'list': '列表',
    'item': '项目',
    'list_a': '列表A',
    'list_b': '列表B',
    'start_index': '起始索引',
    'end_index': '结束索引',
    'index': '索引',
    'value': '数值',
    'value_a': '值A',
    'value_b': '值B',
    'in_min': '输入最小',
    'in_max': '输入最大',
    'out_min': '输出最小',
    'out_max': '输出最大',
    'step': '步长',
    'x': 'X',
    'y': 'Y',
    'z': 'Z',
    'a': '向量A',
    'b': '向量B',
    't': '插值因子',
    'vector': '向量',
    'factor': '因子',
    'plane_normal': '法平面',
    'copy': '复制',
    'direction': '方向',
    'count': '数量',
    'spacing': '间距',
    'count_x': 'X数量',
    'count_y': 'Y数量',
    'fill_angle': '填充角',
    'plane': '绘图平面',
    'is_face': '是否为面',
    'name': '名称',
    'type': '类型',
    'expression': '表达式',
    'Color': '颜色',
    'Top': '顶视图',
    'Front': '前视图',
    'Right': '右视图',
    'Num': '数字',
    'Vec': '向量',
    'Bool': '布尔',
    'Str': '文本',
    'Round': '圆角',
    'Chamfer': '直角',
    'Console': '控制台 / 日志',
    'ParaCad': 'ParaCad',
    'Node Library': '组件库 (拖拽添加)',
    'Search Nodes': '搜索节点',
    'Expand All': '全部展开',
    'Collapse All': '全部折叠',
    'Collapse Others': '折叠其他',
    'No matching nodes': '没有匹配节点',
    'Clear': '清空',
    'Clear Logs': '清空日志',
    'Auto Layout': '自动布局',
    'Fit View': '充满画布',
    'Export JSON': '导出 JSON',
    'Import JSON': '导入 JSON',
    'Examples': '示例',
    'Example Scripts': '示例脚本',
    'Load Example': '加载示例',
    'Load': '加载',
    'Loading': '加载中',
    'Double-click to load': '双击加载',
    'Copy Nodes': '复制节点',
    'Delete Nodes': '删除节点',
    'Initializing...': '正在初始化几何引擎...',
    'Loading Engine': '加载 Three.js 引擎...',
    'Delete Node': '删除节点',
    'Delete Component': '删除组件',
    'Run': '运行',
    'Union': '并集',
    'Subtract': '差集',
    'Intersect': '交集',
    'Language': 'English',
    'Theme Demo': '主题',
    'Light': '浅色',
    'Dark': '深色',
    'No Custom Nodes': '暂无自定义组件',
    'Save in Canvas': '请在画布中保存',
    'Undo': '撤销',
    'Redo': '重做'
  },
  en: {
    'Core': 'Core',
    'Sketch 2D': 'Sketch 2D',
    'Solid Primitives': 'Solid Primitives',
    'Solid Operations': 'Solid Operations',
    'Transform & Array': 'Transform & Array',
    'Measure': 'Measure',
    'Data & Math': 'Data & Math',
    'Basic & Params': 'Basic & Params',
    '2D Shapes': '2D Shapes',
    '3D Solids': '3D Solids',
    'Features': 'Features',
    'Analysis': 'Analysis',
    'Data Flow': 'Data Flow',
    'Math': 'Math',
    'Transforms': 'Transforms',
    'Number Range': 'Number Range',
    'Range By Count': 'Range By Count',
    'List Create': 'List Create',
    'List Length': 'List Length',
    'List Get Item': 'List Get Item',
    'List Flatten': 'List Flatten',
    'List First': 'List First',
    'List Last': 'List Last',
    'Vector Create': 'Vector Create',
    'Vector Add': 'Vector Add',
    'Vector Subtract': 'Vector Subtract',
    'Vector Scale': 'Vector Scale',
    'List Join': 'List Join',
    'List Slice': 'List Slice',
    'List Reverse': 'List Reverse',
    'List Unique': 'List Unique',
    'List Repeat': 'List Repeat',
    'Vector Length': 'Vector Length',
    'Vector Normalize': 'Vector Normalize',
    'Vector Dot': 'Vector Dot',
    'Vector Cross': 'Vector Cross',
    'Vector Distance': 'Vector Distance',
    'Vector Angle': 'Vector Angle',
    'Vector Lerp': 'Vector Lerp',
    'Add': 'Add',
    'Minus': 'Minus',
    'Multiply': 'Multiply',
    'Divide': 'Divide',
    'Power': 'Power',
    'Absolute': 'Absolute',
    'Clamp': 'Clamp',
    'Remap': 'Remap',
    'list': 'List',
    'list_a': 'List A',
    'list_b': 'List B',
    'start_index': 'Start Index',
    'end_index': 'End Index',
    'length': 'Length',
    'item': 'Item',
    'index': 'Index',
    'value': 'Value',
    'value_a': 'Value A',
    'value_b': 'Value B',
    'in_min': 'In Min',
    'in_max': 'In Max',
    'out_min': 'Out Min',
    'out_max': 'Out Max',
    'step': 'Step',
    'x': 'X',
    'y': 'Y',
    'z': 'Z',
    'a': 'Vector A',
    'b': 'Vector B',
    't': 'Factor',
    'vector': 'Vector',
    'Organization': 'Organization',
    'Custom Nodes': 'Custom Nodes',
    'ParaCad': 'ParaCad',
    'Language': '中文',
    'No Custom Nodes': 'No Custom Nodes',
    'Save in Canvas': 'Save via Context Menu',
    'Search Nodes': 'Search Nodes',
    'Expand All': 'Expand All',
    'Collapse All': 'Collapse All',
    'Collapse Others': 'Collapse Others',
    'No matching nodes': 'No matching nodes',
    'Clear': 'Clear',
    'Clear Logs': 'Clear Logs',
    'Examples': 'Examples',
    'Example Scripts': 'Example Scripts',
    'Load Example': 'Load Example',
    'Load': 'Load',
    'Loading': 'Loading',
    'Double-click to load': 'Double-click to load',
    'Theme Demo': 'Theme',
    'Light': 'Light',
    'Dark': 'Dark',
    'Top': 'Top',
    'Front': 'Front',
    'Right': 'Right',
    'Num': 'Num',
    'Vec': 'Vec',
    'Bool': 'Bool',
    'Str': 'Str',
    'Round': 'Round',
    'Chamfer': 'Chamfer',
    'Union': 'Union',
    'Subtract': 'Subtract',
    'Intersect': 'Intersect',
    'operation': 'Operation',
    'name': 'Name',
    'type': 'Type',
    'Value': 'Value'
  }
};

